import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Login from './Login';
import SignUp from './SignUp';
import { playSound, SOUNDS } from '../utils/audio';
import './Auth.css';

const Auth = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('login');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab === 'login' || tab === 'signup') {
      setActiveTab(tab);
    }
  }, [location]);

  const handleAuthSuccess = () => {
    navigate('/');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-tabs">
          <button
            className={`auth-tab ${activeTab === 'login' ? 'active' : ''}`}
            onClick={() => {
              playSound(SOUNDS.TAP);
              setActiveTab('login');
            }}
          >
            Login
          </button>
          <button
            className={`auth-tab ${activeTab === 'signup' ? 'active' : ''}`}
            onClick={() => {
              playSound(SOUNDS.TAP);
              setActiveTab('signup');
            }}
          >
            Sign Up
          </button>
        </div>
        <div className="auth-content">
          {activeTab === 'login' ? (
            <Login onSuccess={handleAuthSuccess} />
          ) : (
            <SignUp onSuccess={handleAuthSuccess} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth;